import {
	createProviderWithCustomFetchData,
	type ExportedDataProvider,
} from './create-data-provider';
import { type AvailableProductsResponse } from '../../types';
import { fetchJsonWithNetworkRetries } from '../utils/fetch';
import { ExperienceMark } from '../utils/experience-tracker';

export const APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT =
	'/gateway/api/app-switcher/api/available-products';

interface Params {
	cloudId?: string;
	product?: string;
}

export const appSwitcherBffAvailableProductsFetch = async ({ cloudId, product }: Params): Promise<AvailableProductsResponse> => {
	const params = new URLSearchParams({ source: 'app-switcher-fe' });
	if (cloudId) {
		params.append('tenantid', encodeURIComponent(cloudId));
	}
	if (product) {
		params.append('product', encodeURIComponent(product));
	}

	return await fetchJsonWithNetworkRetries<AvailableProductsResponse>(
		`${APP_SWITCHER_BFF_AVAILABLE_PRODUCTS_ENDPOINT}?${params.toString()}`,
		{
			intervalsMS: [50, 200, 1000],
		},
		{
			headers: {
				'Atl-App-Switcher-Private-API': 'true',
			},
		},
	);
};

export const createAppSwitcherBffAvailableProductsProvider =
	(): ExportedDataProvider<AvailableProductsResponse> => {
		return createProviderWithCustomFetchData<AvailableProductsResponse, Params>(
			'appSwitcherBffAvailableProducts',
			ExperienceMark.API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS,
			appSwitcherBffAvailableProductsFetch,
		);
	};
